<!--  -->
<template>
    <div class="container">
        <h2>
            <span>{{tourInfo.share_title}}</span>
        </h2>
        <div class="main">
            <dl v-for="(v,i) in erjiTourList" :key="i" >
                <dt>
                    <img :src="v.icon" alt="">
                </dt>
                <dd>
                    {{v.name}}
                </dd>
            </dl>
        </div>
    </div>
</template>
<script>
import eventBus from "@/utils/eventBus.js";

export default {
   data() {
        return {
            tourInfo:{},
            erjiTourList:[]
        }
    },
    created() {
        this.tourInfo=JSON.parse(localStorage.getItem("tourInfo"))
        this.erjiTourList=JSON.parse(localStorage.getItem("tourInfo")).second_service
        console.log(this.erjiTourList)
    },
    
    mounted() {}
}
</script>
<style scoped lang="scss">
.container{
    padding: .5rem .5rem;
    box-sizing: border-box;
}
    h2{
        font-size: 20px;
        font-weight: normal;
        color: #555;
        span{
            border-bottom: 5px solid 	#FFD700;
        }
    }
    .main{
        
    }
</style>


// WEBPACK FOOTER //
// src/views/tourAll.vue